import React from 'react'
import SyntaxHighlighter from 'react-syntax-highlighter/prism-light'
import PropTypes from 'prop-types'

const propTypes = {
  children: PropTypes.node.isRequired,
  language: PropTypes.string.isRequired
}

const CodeSnippet = (props) => {
  const { children, language } = props
  return (
    <SyntaxHighlighter language={language} useInlineStyles={false}>
      {children}
    </SyntaxHighlighter>
  )
}

CodeSnippet.propTypes = propTypes

export default CodeSnippet
